import axios from 'axios'

// axios.defaults.baseURL = process.env.BASE_API
// 判断当前环境使用地址
if (process.env.NODE_ENV !== 'development') {
  axios.defaults.baseURL = window.location.href.split(':')[0] + '://' + window.location.host
} else {
  axios.defaults.baseURL = '/api'
}

const service = axios.create({
  timeout: 40000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=UTF-8'
  }
})
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  () => {
  }
)
export default service



// WEBPACK FOOTER //
// ./src/components/verifyJs/utils/axios.js